import debounce from 'lodash/debounce';
const numberRegex = /\d+/g;
export class Autocomplete {
    constructor(fn, delay = 500) {
        this.debouncedFn = debounce(fn, delay, { leading: false, trailing: true });
    }
    search(query) {
        let searchValue = query.trim();
        // If it's a number, remove any spaces
        if (numberRegex.test(searchValue)) {
            searchValue = searchValue.replace(/\s/g, '');
        }
        if (searchValue.length <= 1)
            return;
        this.debouncedFn(searchValue);
    }
}
